import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/ChildInfo'

/**
 */
class ChildInfo extends BaseProcessor{
  static getClassName(){ return 'ChildInfo' }

  /**
   */
  static get(input){
    return new Promise(function(resolve, reject) {
      API.get(input)
        .then((res)=>{
          return resolve({status:"ok",data:{child_info:res.child_info} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }

  static save(input){
    return new Promise(function(resolve, reject) {
      API.save(input)
        .then((res)=>{
          return resolve({status:"ok",data:{child_info:res.child_info} })
        }).catch((e)=>{
        switch(e.name){
        }
      })
    });
  }
}

export default ChildInfo



// WEBPACK FOOTER //
// ./src/processor/ChildInfo.js